// Core 
import { useState } from 'react';
import { 
  Button,
  Flex, 
  Box,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text, 
} from '@chakra-ui/react';

// Assets
import couponImage from 'assets/img/coupon.png';

const CouponModal = ({onOpen, isOpen, onClose, handleOnClose, setStep, changeStatusSubItem}) => {

  const handleConfirm = async () => {
    setStep(1);
    handleOnClose();
  };

  return (
    	<> 
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent className="modal__simple" 
            maxW={{ sm: '620px' }} 
            style={{ border:'1px solid #2ABDFD', overflow: 'hidden', padding: '0px' }}>
            <ModalCloseButton style={{zIndex: '9'}} />
              <Box bg="rgba(64, 155, 255, 0.82)" filter="blur(70px)" w="90%" h="150px"
                  transform="translate(-50%, 0px)" left="50%" 
                  top="-200px" position="absolute" borderRadius="full" />

              <Image src={couponImage} w="100%" h="265px" objectFit="cover" />

              <Box position="relative" p="24px" textAlign="center">
                  <Text 
                      variant="title-lg"
                      zIndex="3" 
                      fontSize={{base: '24px', md: '32px'}}
                      fontStyle="italic"
                      fontWeight="700"
                      position="relative">Congratulations! Your coupon has been successfully applied.</Text>

                  <Flex  mt="40px" gap="12px">
                    <Button 
                      variant="button-md"
                      onClick={handleConfirm}>Confirm</Button>
                  </Flex>
              </Box>
          </ModalContent>
        </Modal> 
      </>
  );
};

export default CouponModal;